import React, { Component } from 'react';

class PageContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domLoaded: false,
      hasWoobox: false,
    };

    this.prepareWoobox = this.prepareWoobox.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.hasWoobox && this.state.hasWoobox) {
      const wooboxPlugin = function (d, s, id) {
        let js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://woobox.com/js/plugins/woo.js';
        fjs.parentNode.insertBefore(js, fjs);
      };
      wooboxPlugin(document, 'script', 'woobox-sdk');
    }
  }

  prepareContent(content) {
    const pageContent = this.prepareWoobox(content);
    return { __html: pageContent };
  }

  prepareWoobox(contentString) {
    const regex = /\[woobox ?([A-z0-9]*) ?]/gmi;
    const str = contentString;
    if (!regex.test(str)) {
      if (this.state.hasWoobox) {
        this.setState({ hasWoobox: false });
      }
      return str;
    }
    if (!this.state.hasWoobox) {
      this.setState({ hasWoobox: true });
    }

    // The substituted value will be contained in the result variable
    const result = str.replace(regex, (match, captureGroup1) => {
      return `<div class="woobox-offer" data-offer="${captureGroup1}" data-trigger="enter">&nbsp;</div>`;
    });

    return result;
  }

  render() {
    const { content } = this.props;
    return (
      <div className="text-justify" dangerouslySetInnerHTML={this.prepareContent(content)} />
    );
  }
}

export default PageContent;
